import React from 'react';
import PropTypes from 'prop-types';
import { Container, Row, Col } from 'reactstrap';

const Footer = ({ serverStatus }) => {
	return (
		<React.Fragment>
			<footer className={`footer ${!serverStatus ? 'd-none' : ''}`}>
				<Container fluid={true}>
					<Row>
						<Col md={6}>{new Date().getFullYear()} © Ajansspor.</Col>
						<Col md={6}>
							<div className="text-sm-right d-none d-sm-block">Develop by Ajansspor Software</div>
						</Col>
					</Row>
				</Container>
			</footer>
		</React.Fragment>
	);
};

Footer.propTypes = {
	serverStatus: PropTypes.bool,
};

export default Footer;
